import qs from 'qs'
import { useSearchParams } from 'react-router-dom'

export const useTabNavigation = (defaultTabKey?: string) => {
  const [params, setParams] = useSearchParams()

  const keys = qs.parse(params.toString())

  const { tabKey } = keys

  const handleTabChange = (id: string) => {
    setParams({ tabKey: id })
  }

  return { tabKey: (tabKey as string) || defaultTabKey, handleTabChange }
}
